import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useCreateRecruitmentContext } from '../../Create/Contexts/CreateRecruitmentContext';
import StepProps from '../StepProps';
import RequestInformationStepBody from './Components/RequestInformationStepBody';
import RequestInformationStepHeader from './Components/RequestInformationStepHeader';
import RequestInformationStepNavigation from './Components/RequestInformationStepNavigation';
import { informationModel2FormValues } from './RequestInformationStepUtils';
import { cn } from '@/lib/utils';

const RequestInformationStep = ({ activeStep, handleNext, handleBack }: StepProps): React.JSX.Element => {
    const { applicantInformation } = useCreateRecruitmentContext();
    const form = useForm({ defaultValues: informationModel2FormValues(applicantInformation) });

    const submitHandler = () => {
        if (handleNext) {
            handleNext();
        }
    };

    return (
        <div className={cn('mx-auto w-full max-w-211.5 self-center')}>
            <RequestInformationStepHeader />
            <FormProvider {...form}>
                <form onSubmit={form.handleSubmit(submitHandler)} className="flex flex-col">
                    <RequestInformationStepBody />
                    <RequestInformationStepNavigation activeStep={activeStep} handleBack={handleBack} />
                </form>
            </FormProvider>
        </div>
    );
};

export default RequestInformationStep;
